import { AccountEmailValidation } from '../../components/account-email-validation/AccountEmailValidation';

export const EmailValidationView = () => <AccountEmailValidation />;
